import { produce, type SetStoreFunction } from "solid-js/store";
import type { AuthStoreV2 } from "../context/auth-provider";
import type { SessionBootstrapResponse } from "./types";

export const applySessionBootstrapToAuthStore = (
  setAuthStoreV2: SetStoreFunction<AuthStoreV2>,
  context: SessionBootstrapResponse,
) => {
  setAuthStoreV2(
    produce((state) => {
      state.companies = context.publisher_workspaces;
      state.capabilities = context.capabilities;
      state.next_step = context.next_step;
      state.active_subscription_id = context.active_subscription_id;

      if (!state.profile) {
        return;
      }

      state.profile.id = context.profile.id;
      state.profile.email = context.profile.email;
      state.profile.full_name = context.profile.full_name ?? "";
      state.profile.username = context.profile.username;
      state.profile.avatar_url = context.profile.avatar_url;
      state.profile.onboarding_status = context.profile.personal_profile_status;
      state.profile.personal_profile_status =
        context.profile.personal_profile_status;
      state.profile.available_from = context.profile.available_from;
      state.profile.weekly_hours = context.profile.weekly_hours ?? null;
      state.profile.last_selected_workspace_id =
        context.profile.last_selected_workspace_id;
      state.profile.billing_status = context.profile.billing_status;
      state.profile.profile_type = context.capabilities.can_publish
        ? "provider"
        : "consumer";
    }),
  );
};
